import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './PedsInformation.module.css';
import { DBCheckBox, DBRadioButton, DBTextArea, DBTextField, DBDropDown, DBIntField } from '_components';


class PatientCareCenterNoteSubjectivePedsHistory extends React.Component {


    render() {
        return (
            <div>
                <PatientCareCenterNoteSection id='sub_med_hist_peds' name='Pediatric Information' level={2} allowCollapse={false}>
                   
                    <div className={styles.table}>
                        <div className={styles.rows}>
                            <label className={styles.label_col_school}>School:</label>
                            <div className={styles.info_field_school}>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPINFOSCHOOL'
                                    className={styles.text_school_field}
                                    placeholder='School name'
                                />
                            </div>

                            <label className={styles.label_col_school}>Grade:</label>
                            <div className={styles.info_field}>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPINFOGRADE'
                                    className={styles.text_school_field}
                                    placeholder='Grade'
                                />
                            </div>
                        </div>
                    </div>
                </PatientCareCenterNoteSection>
                <PatientCareCenterNoteSection id='sub_med_hist_peds' name='Adjusted Age' level={2} allowCollapse={false} className={styles.textarea_col}>
                    <div className={styles.rows}>
                        <label className={styles.label_col_info_short}>Years:</label>
                        <div className={styles.info_field}>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPADJUSTEDYEARS'
                                className={styles.text_name_field}
                                placeholder='Years'
                            />
                        </div>
                    </div>
                    <div className={styles.rows}>
                        <label className={styles.label_col_info_short}>Months:</label>
                        <div className={styles.info_field}>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPADJUSTEDMONTHS'
                                className={styles.text_name_field}
                                placeholder='Months'
                            />
                        </div>
                    </div>
                    <div className={styles.rows}>
                        <label className={styles.label_col_info_short}>Days:</label>
                        <div className={styles.info_field}>
                            <DBIntField
                                noteId={this.props.noteId}
                                entity='PTEVALPEDS'
                                entityKeyColumn='EVPNO'
                                entityKeyValue={this.props.evpno}
                                field='EVPADJUSTEDDAYS'
                                className={styles.text_name_field}
                                placeholder='Days'
                            />
                        </div>
                    </div>
                </PatientCareCenterNoteSection>
                {this.props.showCDSA &&
                    <>
                        <PatientCareCenterNoteSection id='sub_med_hist_CDSA_reason' name='CDSA: Reason for referral' level={2} allowCollapse={false} className={styles.required}>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSANEWINJ' label='Beneficiary has a new injury, disease or condition' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAONGOINGINJ' label='Beneficiary has an ongoing injury, disease or condition' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAEXACINJ' label='Beneficiary has an exacerbation of an old injury, disease or condition' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSARESCHANGE' label={"There has been a recent change in the beneficiary's residential and/or social situation"} className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSANEWEQUIP' label='Beneficiary has need of new or modified equipment/device(s)' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSANEWCARE' label='Beneficiary has new caregiver(s) in need of training' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAOTHER' label='Other' className={styles.checkbox_col} />
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVALPEDS'
                                    entityKeyColumn='EVPNO'
                                    entityKeyValue={this.props.evpno}
                                    field='EVPSUBMEDCDSAOTHERDETAILS'
                                    className={styles.text_school_field}
                                    placeholder='Details'
                                />
                            </div>
                            <div className={styles.rows}>
                                Details of new circumstances prompting referral:
                            </div>
                            <div className={styles.rows}>
                                <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAREASONDETAILS' className={styles.textarea_col} />
                            </div>

                        </PatientCareCenterNoteSection>
                        <PatientCareCenterNoteSection id='sub_med_hist_CDSA_prev' name='CDSA: History of Previous Therapy' level={2} allowCollapse={false} className={styles.required}>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSANOPREV' label='No previous therapy for this problem' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAYESPREV' label='This provider has been providing treatment for this problem' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSATHISPROVDC' label='This provider has provided therapy for this problem and discharged beneficiary' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSATHISPROVDIFDC' label='This provider has provided therapy for a different problem and discharged beneficiary' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAANOTHERPROVDC' label='Another provider has provided therapy and has discharged beneficiary' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAANOTHERCUR' label='Another provider is also currently providing therapy' className={styles.checkbox_col} />
                            </div>
                            <div className={styles.rows}>
                                Details of therapy history/previous discharge:
                            </div>
                            <div className={styles.rows}>
                                <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPSUBMEDCDSAPREVIOUSDETAILS' className={styles.textarea_col} />
                            </div>
                        </PatientCareCenterNoteSection>
                    </>
                }

                <PatientCareCenterNoteSection id='sub_med_hist_birth' name='Birth History' level={2} allowCollapse={false} className={styles.required}>
                    <div className={styles.radio_row}>
                        <label className={styles.label_col_req_shorter}>Were there any Complications with the pregnancy?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTPREGCOMP'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTPREGCOMP'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>
                    {this.props.pregComp &&
                        <div className={styles.rows}>
                            <label className={styles.label_col_req}>Details:</label>
                            <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPBIRTHHISTPREGCOMPDETAILS' className={styles.textarea_col} />
                        </div>
                    }

                    <div className={styles.radio_row}>
                        <label className={styles.label_col_req_shorter}>Was the child born more than two weeks early or late?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTEARLY'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTEARLY'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>

                    <div className={styles.radio_row}>
                        <label className={styles.label_col_req_shorter}>Were there any Complications during delivery?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTCOMPDELIVERY'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTCOMPDELIVERY'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>
                    {this.props.delivComp &&
                        <div className={styles.rows}>
                            <label className={styles.label_col_req}>Details:</label>
                            <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPBIRTHHISTCOMPDELIVERYDETAILS' className={styles.textarea_col} />
                        </div>
                    }
                    <div className={styles.radio_row}>
                        <label className={styles.label_col_req_shorter}>Did the child remain in the hospital longer than two days following delivery?</label>
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTREMAININHOSP'
                            label='Yes'
                            selectedValue={true}
                            className={styles.radio_col}
                        />
                        <DBRadioButton
                            noteId={this.props.noteId}
                            entity='PTEVALPEDS'
                            entityKeyColumn='EVPNO'
                            entityKeyValue={this.props.evpno}
                            field='EVPBIRTHHISTREMAININHOSP'
                            label='No'
                            selectedValue={false}
                            className={styles.radio_col}
                        />
                    </div>
                </PatientCareCenterNoteSection>
              
                {/* <PatientCareCenterNoteSection id='sub_med_med_team' name='Family History' level={2} allowCollapse={false}>
                    <label className={styles.label_full_top}>Has anyone in the child's immediate family (parents, brothers, sisters) been treated for the following?</label>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTANEMIA' label='Anemia' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTEPI' label='Epilepsy/seizures' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTANXIETY' label='Anxiety' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTHEADACHES' label='Headaches/migraines' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTARTHRITIS' label='Arthritis' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTHEART' label='Heart disease' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTCANCER' label='Cancer' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTHIGHBLOOD' label='High blood pressure' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTDEPRESSION' label='Depression' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTKIDNEY' label='Kidney disease' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTDIABETES' label='Diabetes' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTSTROKE' label='Stroke' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPFAMHISTCOMMENTS' className={styles.textarea_col} />
                    </div>
                </PatientCareCenterNoteSection>
                <PatientCareCenterNoteSection id='sub_med_med_team' name='Medical Team' level={2} allowCollapse={false}>
                    <label className={styles.label_full_top}>Has the child seen any of the following providers in the last six months? If so, please provide names and phone numbers.</label>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMAUDIO' label='Audiologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMCHIRO' label='Chiropractor' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMCARDIO' label='Cardiologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMDEVCLINIC' label='Developmental Clinic' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMIMMUNO' label='Immunologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMPEDI' label='Pediatrician/medical doctor' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMNEPHRO' label='Nephrologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMPHYSCHO' label='Psychologist/psychiatrist' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMNEPHRO' label='Nephrologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMPHYSCHO' label='Psychologist/psychiatrist' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMNEURO' label='Neurologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMPULMA' label='Pulmanologist' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMOPTHALMO' label='Ophthalmologist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMRHEUM' label='Rheumatologist' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.checkbox_row}>
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMORTHO' label='Orthopedist' className={styles.checkbox_col} />
                        <DBCheckBox noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMOTHER' label='Other' className={styles.checkbox_col} />
                    </div>
                    <div className={styles.textarea_row} id='sub_med_hist_comorb_allergy'>
                        <DBTextArea noteId={this.props.noteId} entity='PTEVALPEDS' entityKeyColumn='EVPNO' entityKeyValue={this.props.evpno} field='EVPMEDTEAMOTHERDETAILS' className={styles.textarea_col} />
                    </div>
                </PatientCareCenterNoteSection> */}




            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        clearFields: bindActionCreators(noteActions.clearFields, dispatch)
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTEVAL[evno].EVEPNO;
    let evpno = Object.keys(state.entities.notes.PTEVALPEDS)
        //peds info
        .find(key => (state.entities.notes.PTEVALPEDS[key].EVPEVNO === evno));


    let pregComp = state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTPREGCOMP;
    let delivComp = state.entities.notes.PTEVALPEDS[evpno].EVPBIRTHHISTCOMPDELIVERY;
    let showCDSA = false;
    if (state.entities.admissions[epno].primaryPYNO + "" === state.entities.masterData.PROPS['SAPPHIRE_CDSA_PYNO'].PRVALUE) {
        showCDSA = true;
    }



    return {
        noteId: noteId,
        evno: evno,
        comorbNone: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMNONE : false,
        comorbAllergies: state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES ? state.entities.notes.PTEVAL[evno].EVSUBMEDCOMALLERGIES : false,
        pregComp,
        delivComp,
        evpno,
        showCDSA,

    };
}

const connectedPatientCareCenterNoteSubjectivePedsHistory = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectivePedsHistory);
export { connectedPatientCareCenterNoteSubjectivePedsHistory as PatientCareCenterNoteSubjectivePedsHistory };

